<template>
  <div>
    <SearchBox ref="SearchBox">
      <el-form slot="form"
               :inline="true"
               ref="searchParams"
               label-width="80px"
               class="unitWidth"
               size="small">
        <el-form-item :label="$t('Shift.factory')">
          <el-select v-model="fcCode"
                     :placeholder="$t('base.PleaseSelect')"
                     filterable
                     :disabled="ischeck"
                     @change="getCodeInit">
            <el-option v-for="factory in factoryList"
                       :key="factory.factoryId"
                       :label="factory.fcName"
                       :value="factory.fcCode"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
    </SearchBox>
    <div>
      <div style="width:calc(100% - 20px);text-align:right;margin:10px">
        <el-button type="primary"
                   style="margin-left:20px"
                   @click="submit">{{$t('base.save')}}</el-button>
      </div>
      <div class="el-steps el-steps--horizontal"
           style="width:100%;transform: scale(1.1); margin-top: 10%;">
        <div class="el-step is-horizontal is-center"
             style="flex-basis: 25%; margin-right: 0px;cursor: pointer;"
             v-for="(item,index) in checkSteps"
             :key="index"
             @click="stepsChange(index,item)">
          <div :class="item.isCheck?'el-step__head is-success':'el-step__head is-wait'">
            <div class="el-step__line"
                 style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: 0ms; border-width: 0px; width: 0%;"></i>
            </div>
            <div class="el-step__icon is-text">
              <i v-if="item.isCheck"
                 class="el-step__icon-inner is-status el-icon-check"></i>
              <div v-else
                   class="el-step__icon-inner">{{index+1}}</div>
            </div>
          </div>
          <div class="el-step__main">
            <div :class="item.isCheck?'el-step__title is-success':'el-step__title is-wait'">{{item.desc}}</div>
            <div class="el-step__description is-success"></div>
          </div>
        </div>
      </div>
      <el-checkbox v-model="checkSteps[checkValue].isCheck"
                   style="margin-top:60px;text-align:center;width:100%"
                   @change="checkValueChange">{{checkSteps[checkValue].desc+$t('menu.Scan')}}</el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      checkSteps: [],
      fcCode: '',
      factoryList: [],
      userInfo: {},
      role: {},
      ischeck: true,
      stepsCodeList: [],
      checkValue: 0,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    getCodeInit () {
      var self = this
      self.stepsCodeList = []
      let options = {
        method: 'GET',
        url: this.$api.getAndonScanningCodeParam,
        params: {
          fcCode: self.fcCode
        }
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data) {
            let data = response.data
            self.stepsCodeList = data
            self.getStepsInit()
          }
        }
      })
    },
    getStepsInit () {
      var self = this
      self.checkSteps = []
      let options = {
        method: 'GET',
        url: this.$api.getAndonOperationList
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data) {
            let data = response.data
            data.forEach((item, index) => {
              switch (item.code) {
                case 'andon_taking':
                  data[index]['isCheck'] = self.stepsCodeList.andonTaking
                  break
                case 'andon_start_maintenance':
                  data[index]['isCheck'] = self.stepsCodeList.andonStartMaintenance
                  break
                case 'andon_repair_completed':
                  data[index]['isCheck'] = self.stepsCodeList.andonRepairCompleted
                  break
                case 'andon_accept':
                  data[index]['isCheck'] = self.stepsCodeList.andonAccept
                  break
              }
            });
            self.checkSteps = data
          }
        }
      })
    },
    init () {
      this.access = JSON.parse(sessionStorage.getItem('auths'))
      // this.userInfo = sessionStorage.getItem("userInfo")
      this.userInfo = this.$store.state.userInfo
      var role = this.userInfo.roles
      for (var i = 0; i < role.length; i++) {
        //所有工厂数据
        if (role[i].factoryId == 0) {
          this.ischeck = false
          this.role = role[i]
          break
        } else {
          if (this.userInfo.factoryId == role[i].factoryId) {
            this.role = role[i]
          }
        }
      }
      this.getAllFactory()
    },
    getAllFactory () {
      let options = {
        method: 'get',
        url: this.$api.getAllFactory
      }
      this.$http.request(options).then(response => {
        this.factoryList = []
        var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        var aa = response.data
        if (this.ischeck) {
          for (var i = 0; i < aa.length; i++) {
            for (let j = 0; j < userInfo.roles.length; j++) {
              if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                this.factoryList.push(aa[i])
                this.fcCode = this.userInfo.fcCode
              }
            }
          }
        } else {
          this.fcCode = response.data[0].fcCode
          this.factoryList = response.data
        }
        this.getCodeInit()
      })
    },
    stepsChange (index) {
      this.checkValue = index
    },
    checkValueChange (e) {
      this.checkSteps[this.checkValue].isCheck = e
    },
    submit () {
      let self = this
      let data = this.checkSteps
      data.forEach((item, index) => {
        switch (item.code) {
          case 'andon_taking':
            self.stepsCodeList.andonTaking = item.isCheck
            break
          case 'andon_start_maintenance':
            self.stepsCodeList.andonStartMaintenance = item.isCheck
            break
          case 'andon_repair_completed':
            self.stepsCodeList.andonRepairCompleted = item.isCheck
            break
          case 'andon_accept':
            self.stepsCodeList.andonAccept = item.isCheck
            break
        }
      });
      self.saveCode(self.stepsCodeList)
    },
    saveCode (data) {
      var self = this
      let options = {
        method: 'POST',
        url: this.$api.saveAndonScanningCodeParam,
        data,
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          self.$message({
            message: this.$t('base.SuccessfullyUpdated'),
            type: 'success'
          });
        }
        self.getStepsInit()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.el-container .el-container .el-main .pageBox > div {
    text-align: left;
}
</style>
